import Vue from 'vue'
import { mapState } from 'vuex'
import {
  deepClone
} from 'utils/general'

Vue.component('account-address-item', {
  props: [
    'firstName',
    'lastName',
    'company',
    'address1',
    'address2',
    'city',
    'province',
    'zip',
    'order',
    'country',
    'country-full',
    'phone',
    'isDefault',
    'id',
    'customer'
  ],
  computed: {
    ...mapState('global', ['defaultAddressId']),
    showAsDefault () {
      if (this.defaultAddressId !== null) {
        return this.id === this.defaultAddressId
      }
      return this.isDefault
    }
  },
  methods: {
    update () {
      this.$emit('update', [deepClone(this.$options.propsData), this.order])
    },
    setDefault () {
      const submission = new FormData()
      submission.append('address[default]', true)
      submission.append('form_type', 'customer_address')
      submission.append('_method', 'put')

      fetch(`/account/addresses/${this.id}`, {
        method: 'post',
        body: submission
      }).then(response => {
        this.$store.commit('global/setDefaultAddress', this.id)
      }).catch(error => {
        console.warn(error)
      })
    },
    remove () {
      if (
        !confirm('Are you sure that you want to delete this address?')
      ) return

      const form = document.createElement('form')
      const input = document.createElement('input')

      form.setAttribute('method', 'post')
      form.setAttribute('action', '/account/addresses/' + this.id)

      input.setAttribute('type', 'hidden')
      input.setAttribute('name', '_method')
      input.setAttribute('value', 'delete')

      form.appendChild(input)

      document.body.appendChild(form)
      form.submit()
      document.body.removeChild(form)
    }
  }
})
